export const isLocal = process.env.NODE_ENV === 'development'
export const isTest = !!process.env.GATSBY_STAGING
export const isProd = !isLocal && !isTest
